import type { HTMLAttributes } from 'react'
import { cls } from './cls'

/** A centred, quiet line of text standing in for absent content — an empty
 *  table body, a panel with nothing to show yet. For a full empty *state*
 *  with a heading and an action, see components/EmptyState. */
export function EmptyHint({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cls('p-7 text-center text-ink-500 text-[13px]', className)} {...rest} />
}
